import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  BoardTableContainer,
  RowSpan,
} from "../../assets/GlobalStyles";
import Table from "../../components/table";
import React, {useEffect, useState} from "react";
import {atom, useAtom} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import {selPolicyTerms} from "../../services/Platform/TermsAxios";
import {columnTermData} from "./entity/Common";

const termList = atom([])
export default function PlatformTerm(){
  const [termList, setTermList] = useState([])
  const [totalInfo,setTotalInfo] = useState(dataTotalInfo)

  useEffect(()=>{
    selPolicyTerms().then(response =>{

      if(response !== null){
        setTermList(response)
        setTotalInfo({
          totalCount: response.length,
          totalPages: response.length,
          currentPage:response.length
        })
      }
    })
  },[])


  return(
    <Board>
      <BoardHeader>약관 관리</BoardHeader>
      <BoardSearchDetail>
        {/*line1*/}
        <RowSpan></RowSpan>
      </BoardSearchDetail>
      <BoardTableContainer>
        <Table columns={columnTermData}
               totalCount={[totalInfo.totalCount, '약관']}
               data={termList !== null ? termList : []}/>
      </BoardTableContainer>
    </Board>
  )
}